export default __webpack_public_path__ + "static/media/README.e9ac75d1.md";